"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var poweredByFixtuur_1 = require("./icons/poweredByFixtuur");
/**
 * The FullScreenTakeover Template
 *
 * This component purposefully is unopinionated on the how the layout of
 * its children fits within it. This should be managed on a per-use basis.
 */
var Component = function (p) {
    var _a;
    return (Preact.h(Box_1.default, { sx: __assign({ position: 'absolute', left: '0px', top: '0px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: '100%', width: '100%', backgroundColor: 'background.default' }, p.sx) },
        Preact.h(Box_1.default, { sx: {
                display: 'flex',
                justifyContent: 'flex-start',
                width: '100%',
            } }, p.onClose ? (Preact.h(IconButton_1.default, { onClick: p.onClose, sx: { marginLeft: '22px', marginTop: '24px' } },
            Preact.h(Close_1.default, { width: "18px" }))) : null), (_a = p.children) !== null && _a !== void 0 ? _a : null,
        Preact.h(Box_1.default, { sx: { display: 'flex', justifyContent: 'center', paddingBottom: '58px' } },
            Preact.h(poweredByFixtuur_1.PoweredByFixtuurIcon, { sx: { height: { xs: '22px', sm: '26px' }, width: 'auto' } }))));
};
exports.Component = Component;
exports.Component.displayName = 'FullScreenTakeover';
